import React from "react";
import {
    Card,
    CardBody,
    Modal,
    ModalBody,
} from "reactstrap";
import imgSuccess from "assets/images/success.png";

const SuccessModal = ({ modal, message, onClick, title = "", subtitle = "" }) => {
    return (
        <Modal isOpen={modal}>
            <ModalBody>
                <div className='overflow-hidden'>
                    <h5 className='fw-bold font-size-18 fw-bold '>{title}</h5>
                    <p style={{ opacity: .5 }}>{subtitle}</p>
                    <div className="text-center">
                        <img src={imgSuccess} className='img-fluid' />
                        <p className='fw-bold font-size-18 fw-bold pt-4 pb-3'>{message}</p>
                        <button className="btn btn-success w-100 "  onClick={onClick}>Done</button>
                    </div>
                </div>
            </ModalBody>
        </Modal>
    )
}

export default SuccessModal